module.exports = __webpack_public_path__ + "static/media/medha.1e7a0037.jpg";